import React from 'react';
import IconSelector from '@ibibo/icon-selector';

import * as S from './UploadInfo.styles';

const UploadReset = ({reset, close}) => {
    return(
        <S.UploadedFileInfo>
            <IconSelector iconKey='file' />
            <S.DocumentTickWrap>
                <IconSelector iconKey='tickmarkwhite' props={{width:"0.8rem", height:"0.8rem"}}/>
            </S.DocumentTickWrap>
            {close ? <S.CloseIcon >x</S.CloseIcon> : ''}
        </S.UploadedFileInfo>
    )
}

export default UploadReset;